import { render, staticRenderFns } from "./DragSelector.vue?vue&type=template&id=4d89588c"
import script from "./DragSelector.vue?vue&type=script&lang=ts"
export * from "./DragSelector.vue?vue&type=script&lang=ts"
import style0 from "./DragSelector.vue?vue&type=style&index=0&id=4d89588c&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports